import {useFetchInstitutionsQuery} from './use-fetch-institutions-query';

export function useCountry(institutionId: string, skip: boolean = false): string {
    const {data} = useFetchInstitutionsQuery({variables: {institutionId}, skip: skip || !institutionId});
    return data?.institutions[0]?.details?.address?.country ?? '';
}
